var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dictionary-modal-table',{attrs:{"dictionary_link":"/materials","title":"Lista materiałów","numeral_text":['materiał', 'materiały', 'materiałów'],"columns_title":['name']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }